<template>
  <div class="process_form">
    <el-main>
      <section class="section">
        <h2 class="title">Update Your 2024 Car Insurance</h2>
        <div class="cart">
          <h3 class="title">Your Progress</h3>
          <span class="num">{{ percentage }}%</span>
          <el-progress
            :percentage="percentage"
            :stroke-width="15"
            :show-text="false"
            define-back-color="rgba(222, 222, 222, 1)"
            color="rgba(82, 178, 222, 1)"
          ></el-progress>
          <div v-if="from.nowcard == 1">
            <p class="tips">Select Vehicle Year</p>
            <div class="btn-group">
              <div
                :class="
                  (issecondcard ? from.caryear2 : from.caryear) == 2024 - i
                    ? 'btn active w20'
                    : 'btn w20'
                "
                v-for="(i, index) in 40"
                :id="car_yaer_id + index"
                :key="i"
              >
                <input
                  class="checkbox-btn"
                  :id="car_yaer_id + (2024 - i)"
                  :value="2024 - i"
                  :name="issecondcard ? 'car_year_2' : 'car_year_1'"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="carYearButton"
                />
                <label
                  :for="car_yaer_id + (2024 - i)"
                  @click="caryear(2024 - i)"
                  >{{ 2024 - i }}</label
                >
              </div>

              <p class="clearflex"></p>
            </div>
          </div>
          <div v-if="from.nowcard == 2">
            <p class="tips">Select Vehicle Make</p>
            <div class="btn-group">
              <div
                :class="
                  (issecondcard ? from.carmake2 : from.carmake) ==
                  Object.keys(i)[0]
                    ? 'btn active w145'
                    : 'btn w145'
                "
                v-for="(i, index) in radiomakeoption"
                :key="Object.keys(i)[0]"
                :id="car_make_id + index"
              >
                <input
                  class="checkbox-btn"
                  :id="car_make_id + Object.keys(i)[0]"
                  :value="Object.keys(i)[0]"
                  :name="issecondcard ? 'car_make_2' : 'car_make_1'"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="carMakeButton"
                />
                <label
                  :for="car_make_id + Object.keys(i)[0]"
                  @click="clickcarmake(Object.keys(i)[0])"
                >
                  {{ Object.keys(i)[0] }}
                </label>
              </div>
            </div>
            <div class="row">
              <el-select
                id="car_make_input_1"
                :name="issecondcard ? 'car_make_2' : 'car_make_1'"
                class="input_txt car_make"
                v-model="from.carmake"
                placeholder="Select Other Make"
                @change="clickcarmake"
                filterable
              >
                <el-option :value="''">Select Other Make</el-option>
                <el-option
                  v-for="(i, index) in selectradiomakeoption"
                  :key="Object.keys(i)[0]"
                  :id="`car_make_input_1_${index}`"
                  :value="Object.keys(i)[0]"
                  >{{ Object.keys(i)[0] }}</el-option
                >
              </el-select>
            </div>
          </div>
          <div v-if="from.nowcard == 3">
            <p class="tips">Select Vehicle Model</p>
            <div class="row">
              <el-input
                id="car_model_input_0"
                name="input_txt car_model"
                class="car_model"
                v-model="from.carmodel"
                placeholder="Search"
                popper-class="popperclass"
                @input="querySearch"
                :debounce="1000"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="btn-group">
              <div
                :class="
                  (issecondcard ? from.carmodel2 : from.carmodel) == i.name
                    ? 'btn active w145'
                    : 'btn w145'
                "
                v-for="(i, index) in carmodeloption"
                :key="i.code"
                :id="car_model_id + index"
              >
                <input
                  class="checkbox-btn"
                  :id="i.name"
                  :value="i.name"
                  :name="issecondcard ? 'car_model_2' : 'car_model_1'"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="carModelButton"
                />
                <label :for="i.name" @click="moelclick(i.name)">
                  {{ i.name }}
                </label>
              </div>
              <p class="clearflex"></p>
            </div>
          </div>
          <div v-if="from.nowcard == 4">
            <p class="tips">Add Second Vehicle? (Save up to 25%)</p>
            <div class="btn-group">
              <div
                :class="issecondcard == true ? 'btn active w100' : 'btn w100'"
              >
                <input
                  class="checkbox-btn"
                  id="Yes"
                  value="Yes"
                  name="second_car"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="secondCarButton"
                />
                <label for="Yes" @click="isaddsecond(true)">YES</label>
              </div>
              <div
                :class="issecondcard == false ? 'btn active w100' : 'btn w100'"
              >
                <input
                  class="checkbox-btn"
                  id="NO"
                  value="NO"
                  name="second_car"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="secondCarButton"
                />
                <label for="NO" @click="isaddsecond(false)">NO</label>
              </div>
            </div>
          </div>
          <div v-if="from.nowcard == 5">
            <p class="tips">Are You Currently Insured?</p>
            <div class="btn-group">
              <div
                :class="
                  this.from.iscurrentlyinsured === true
                    ? 'btn w100 active'
                    : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="Yes"
                  value="Yes"
                  name="currently_insured"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="currentlyInsuredButton"
                />
                <label for="Yes" @click="iscurrentlyinsured(true)">YES</label>
              </div>
              <div
                :class="
                  this.from.iscurrentlyinsured === false
                    ? 'btn w100 active'
                    : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="No"
                  value="No"
                  name="currently_insured"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="currentlyInsuredButton"
                />
                <label for="Yes" @click="iscurrentlyinsured(false)">No</label>
              </div>
            </div>
          </div>
          <div v-if="from.nowcard == 6">
            <p class="tips">What Company are You Insured With?</p>
            <div class="checked">
              <div
                style="text-wrap: nowrap"
                :class="
                  from.company == i.value ? 'btn w145 active' : 'btn w145'
                "
                :id="what_company + index"
                v-for="(i, index) in companyoption"
                :key="i.key"
              >
                <input
                  class="checkbox-btn"
                  :id="i.value"
                  :value="i.value"
                  name="current_company"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="homeOwnerButton"
                />
                <label :for="i.value" @click="whatcompany(i.value)">{{
                  i.key
                }}</label>
              </div>
              <p class="clearflex"></p>
            </div>
          </div>
          <div v-if="from.nowcard == 7">
            <p class="tips">Are You a Home Owner?</p>
            <div class="checked">
              <div
                :class="
                  this.from.ishomeowner == true
                    ? 'btn w100 active '
                    : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="Yes"
                  value="Yes"
                  name="home_owner"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="homeOwnerButton"
                />
                <label for="Yes" @click="ishomeowner(true)">YES</label>
              </div>
              <div
                :class="
                  this.from.ishomeowner == false
                    ? 'btn w100 active'
                    : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="No"
                  value="No"
                  name="home_owner"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="homeOwnerButton"
                />
                <label for="Yes" @click="ishomeowner(false)">No</label>
              </div>
            </div>
            <img
              height="1"
              width="1"
              style="display: none"
              src="https://www.facebook.com/tr?id=337605789289743&ev=ViewContent&noscript=1"
            />
          </div>
          <!-- <div v-if="from.nowcard == 8">
            <p class="tips">What Month is Your Birthday?</p>
            <div class="btn-group">
              <el-button :class="from.birthday == i ? 'btn active w100' : 'btn w100'" v-for="(i, index) in Birthdayoption"
                :key="i" @click.native="birthday(i)" :id="birthday_month_id + index">{{ i }}</el-button>
              <p class="clearflex"></p>
            </div>
          </div> -->
          <div v-if="from.nowcard == 8">
            <p class="tips">What is Your Date of Birth?</p>
            <div class="btn-group birth_group" style="margin-bottom: 20px">
              <el-select
                @change="changeMonth"
                class="input_txt birth_input"
                name="birth_month"
                v-model="from.month"
                placeholder="Month"
                no-match-text="No Match Data"
                no-data-text="No Data"
                filterable
              >
                <el-option
                  v-for="item in monthOptions"
                  :key="item.value"
                  :value="item.value"
                  :name="item.name"
                ></el-option>
              </el-select>
              <el-select
                class="input_txt birth_input"
                name="birth_day"
                v-model="from.day"
                placeholder="Day"
                no-match-text="No Match Data"
                no-data-text="Select Month"
                filterable
              >
                <el-option
                  v-for="item in dayOptions"
                  :key="item.value"
                  :value="item.value"
                  :name="item.name"
                ></el-option>
              </el-select>
              <!-- <el-date-picker v-model="from.day" type="date" placeholder="Select A Date " format="MM/dd/yyyy" editable
                size="large" align="center" ref="datePick">
              </el-date-picker> -->
              <el-select
                class="input_txt birth_input"
                ref="year"
                name="birth_year"
                v-model="from.year"
                placeholder="Year"
                no-match-text="No Match Data"
                no-data-text="No Data"
                filterable
              >
                <el-option
                  v-for="item in yearOptions"
                  :key="item.value"
                  :value="item.value"
                  :name="item.name"
                ></el-option>
              </el-select>
            </div>
            <div class="errortext" v-if="istruebirth">
              Please enter a valid date
            </div>
            <el-button
              class="next_btn"
              style="
                background: rgb(28, 56, 136);
                color: rgba(255, 255, 255, 1);
                width: 150px;
              "
              @click.native="birthdayContinue"
            >
              <span>Continue</span>
            </el-button>
          </div>
          <!-- <div v-if="from.nowcard == 9">
            <p class="tips">What Year Were You Born?</p>
            <div>
              <el-input
                name="born_input"
                style="margin-bottom: 20px"
                class="input_txt yearinput"
                id="born_input_0"
                v-model="from.birthyear"
                placeholder="YYYY"
                maxlength="4"
                oninput="value = value.replace(/[^\d]/g,'')"
                :class="{ errorinput: istrueyear }"
              ></el-input>
              <div class="errortext" v-if="istrueyear">
                Please enter a valid date
              </div>
            </div>
            <el-button
              class="next_btn"
              style="
                background: rgb(28, 56, 136);
                color: rgba(255, 255, 255, 1);
                width: 150px;
              "
              @click.native="yearcontinue"
            >
              <span>Continue</span>
            </el-button>
          </div> -->
          <div v-if="from.nowcard == 9">
            <p class="tips">What is Your Gender?</p>
            <div class="checked">
              <div
                :class="from.gender == 'Male' ? 'btn w100 active' : 'btn w100'"
              >
                <input
                  class="checkbox-btn"
                  id="Male"
                  value="Male"
                  name="gender"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="genderButton"
                />
                <label for="Male" @click="whatGender('Male')">Male</label>
              </div>
              <div
                :class="
                  from.gender == 'Female' ? 'btn w100 active' : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="Female"
                  value="Female"
                  name="gender"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="genderButton"
                />
                <label for="Female" @click="whatGender('Female')">Female</label>
              </div>
              <p class="clearflex"></p>
            </div>
          </div>
          <div v-if="from.nowcard == 10">
            <p class="tips">Are You Married?</p>
            <div class="checked">
              <div
                :class="
                  this.from.married == 'Married'
                    ? 'btn w100 active'
                    : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="Married"
                  value="Married"
                  name="isMarried"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="isMarriedButton"
                />
                <label for="Married" @click="isMarried('Married')">YES</label>
              </div>
              <div
                :class="
                  this.from.married == 'Single' ? 'btn w100 active' : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="Single"
                  value="Single"
                  name="isMarried"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="isMarriedButton"
                />
                <label for="Single" @click="isMarried('Single')">NO</label>
              </div>
            </div>
          </div>
          <div v-if="from.nowcard == 11">
            <p class="tips">Any at-fault Accidents in the Last 3 years?</p>
            <div class="checked">
              <div
                :class="
                  this.from.Accidents == 'Yes' ? 'btn w100 active' : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="Yes"
                  value="Yes"
                  name="isAccidents"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="isAccidentsButton"
                />
                <label for="Yes" @click="isAccidents('Yes')">YES</label>
              </div>
              <div
                :class="
                  this.from.Accidents == 'No' ? 'btn w100 active' : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="No"
                  value="No"
                  name="isAccidents"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="isAccidentsButton"
                />
                <label for="No" @click="isAccidents('No')">NO</label>
              </div>
            </div>
          </div>
          <div v-if="from.nowcard == 12">
            <p class="tips">DUI in the Last 5 years?</p>
            <div class="checked">
              <div
                :class="this.from.DUI == 'Yes' ? 'btn w100 active' : 'btn w100'"
              >
                <input
                  class="checkbox-btn"
                  id="Yes"
                  value="Yes"
                  name="isDUI"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="isDUIButton"
                />
                <label for="Yes" @click="isDUI('Yes')">YES</label>
              </div>
              <div
                :class="this.from.DUI == 'No' ? 'btn w100 active' : 'btn w100'"
              >
                <input
                  class="checkbox-btn"
                  id="No"
                  value="No"
                  name="isDUI"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="isDUIButton"
                />
                <label for="No" @click="isDUI('No')">NO</label>
              </div>
            </div>
          </div>
          <div v-if="from.nowcard == 13">
            <p class="tips">What is Your Name?</p>
            <div>
              <el-input
                name="fiest_name"
                id="fiest_name"
                class="input_txt carmakestyle"
                placeholder="First Name"
                v-model="from.firstname"
                v-on:input="nameInput($event, 'firstname')"
                :class="{ errorinput: isfirstname }"
                maxlength="20"
              ></el-input>
              <div class="errortext" v-if="isfirstname">
                Please enter First Name
              </div>
            </div>
            <div style="margin-top: 10px">
              <el-input
                name="last_name"
                id="last_name"
                class="input_txt carmakestyle"
                placeholder="Last Name"
                v-model="from.lastname"
                v-on:input="nameInput($event, 'lastname')"
                :class="{ errorinput: islastname }"
                maxlength="20"
              ></el-input>
              <div class="errortext" v-if="islastname">
                Please enter Last Name
              </div>
            </div>
            <el-button
              class="next_btn"
              style="
                background: rgb(28, 56, 136);
                color: rgba(255, 255, 255, 1);
                margin-top: 30px;
              "
              @click.native="whatname()"
              >Continue</el-button
            >
          </div>
          <div v-if="from.nowcard == 14">
            <!-- <p class="tips">
              Have You or Anyone in Your Family Served in the Military?
            </p> -->
            <label class="tips" for="Military"
              >Have You or Anyone in Your Family Served in the Military?</label
            >
            <div class="checked">
              <div
                id="Military-0"
                :class="
                  this.from.Military === true ? 'btn w100 active' : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="Yes"
                  value="Yes"
                  name="isMilitary"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="isMilitaryButton"
                />
                <label for="Yes" @click="isMilitary(true)">YES</label>
              </div>
              <div
                id="Military-0"
                :class="
                  this.from.Military === false ? 'btn w100 active' : 'btn w100'
                "
              >
                <input
                  class="checkbox-btn"
                  id="No"
                  value="No"
                  name="isMilitary"
                  type="radio"
                  required=""
                  data-traceable=""
                  data-traceable-point="isMilitaryButton"
                />
                <label for="No" @click="isMilitary(false)">NO</label>
              </div>
            </div>
          </div>
          <div v-if="from.nowcard == 15">
            <p class="tips">What is Your Address?</p>
            <el-row class="optiongroup">
              <el-col :xs="23" :sm="18" class="addressinputright">
                <el-autocomplete
                  name="Address"
                  id="Address_0"
                  class="input_txt carmakestyle"
                  placeholder="Address"
                  v-model="from.Address"
                  :class="{ errorinput: isAddress }"
                  :fetch-suggestions="autocompleteSearch"
                  :trigger-on-focus="false"
                  ref="autocomplete"
                  @select="handleSelect"
                  @input="() => (isAddress = false)"
                ></el-autocomplete>
                <div class="errortext" v-if="isAddress">
                  Address is required
                </div>
              </el-col>
              <el-col :xs="23" :sm="6" class="addressinputleft">
                <el-input
                  name="Unit"
                  id="Unit_0"
                  class="input_txt carmakestyle"
                  placeholder="Unit#"
                  v-model="from.Unit"
                ></el-input>
              </el-col>
              <el-col
                :xs="23"
                :sm="24"
                class="addressinput mobaddressinputleft"
              >
                <el-input
                  ref="cityinput"
                  name="City"
                  id="City_0"
                  class="input_txt carmakestyle"
                  placeholder="City"
                  v-model="from.City"
                  :class="{ errorinput: isCity }"
                ></el-input>
                <div class="errortext" v-if="isCity">City is required</div>
              </el-col>
              <el-col :xs="12" :sm="12" class="addressinputright">
                <el-select
                  ref="stateinput"
                  name="State"
                  id="State_0"
                  v-model="from.State"
                  placeholder="Select Other Make"
                  class="input_txt carmakestyle"
                  filterable
                >
                  <el-option :value="''">Select Other Make</el-option>
                  <!-- <el-option v-for="i in us_state_map" :key="i" :value="i">{{
            i
          }}</el-option> -->
                  <el-option
                    v-for="[key, value] in Object.entries(us_state_map)"
                    :key="key"
                    :value="key"
                    >{{ value }}</el-option
                  >
                </el-select>
              </el-col>
              <el-col :xs="11" :sm="12" class="addressinputleft">
                <el-input
                  ref="zipinput"
                  name="Zip"
                  id="Zip_0"
                  class="input_txt carmakestyle"
                  placeholder="Zip"
                  v-model="from.Zip"
                  :class="{ errorinput: isZip }"
                  maxlength="5"
                  oninput="value = value.replace(/[^\d]/g,'')"
                ></el-input>
                <div class="errortext" v-if="isZip">
                  Please enter a valid Zip
                </div>
              </el-col>
            </el-row>
            <el-button
              class="next_btn md20"
              style="
                background: rgb(28, 56, 136);
                color: rgba(255, 255, 255, 1);
                margin-top: 30px;
              "
              @click.native="addaddress"
              >Continue</el-button
            >
          </div>
          <div v-if="from.nowcard == 16">
            <p class="tips">What is Your Email?</p>
            <div>
              <el-input
                name="email"
                id="email_0"
                class="input_txt carmakestyle"
                placeholder="Email"
                v-model="from.Email"
                :class="{ errorinput: isEmail }"
                @input="
                  () => {
                    isEmail = false;
                  }
                "
              ></el-input>
              <div class="errortext" v-if="isEmail">
                Please enter a valid email address
              </div>
            </div>
            <div
              v-loading="emailloading"
              style="
                width: 130px;
                height: 46px;
                margin: 0px auto;
                margin-top: 30px;
              "
            >
              <el-button
                class="next_btn"
                style="
                  background: rgb(28, 56, 136);
                  color: rgba(255, 255, 255, 1);
                "
                @click.native="clickEmail"
              >
                <span>Continue</span>
              </el-button>
            </div>
          </div>
          <div v-if="from.nowcard == 17">
            <!-- <p>Last Step, Lliu.</p>
            <p>Rates for your 2022 Ford Ecosport are Ready!</p> -->
            <p class="tips">What is Your Phone Number?</p>
            <div>
              <el-input
                v-model="from.phoneNum"
                :class="{ errorinput: isphoneNum }"
                name="Phone_Number"
                id="Phone_Number_0"
                placeholder="Phone Number"
                maxlength="12"
                class="input_txt phone_txt"
                @input="formatPhoneInput($event)"
                @change="formatPhoneNumber($event)"
              ></el-input>
              <div class="errortext" v-if="isphoneNum">
                Please enter a valid Phone number
              </div>
            </div>
            <div
              v-loading="numloading"
              style="
                width: 150px;
                height: 46px;
                margin: 0px auto;
                margin-top: 30px;
              "
            >
              <el-button
                class="next_btn"
                style="
                  background: rgb(28, 56, 136);
                  color: rgba(255, 255, 255, 1);
                  width: 150px;
                "
                @click.native="fromcontinue"
              >
                <span>Continue</span>
              </el-button>
            </div>
          </div>
          <div class="error">
            <div class="error_inner" v-if="from.nowcard != 18">
              <i class="el-icon-check fsize20"></i> You could save up to
              <strong>25%</strong> by insuring multiple vehicles
            </div>
            <div class="error_inner" v-else>
              <i class="el-icon-check fsize20"></i> Your car quotes are ready
            </div>
          </div>
          <span class="back-icon" @click="back">
            <img src="@/assets/imgs/back.webp" />
          </span>
        </div>
        <div class="content" v-if="from.nowcard == 18">
          <p>
            By clicking the "Get Quote" button, I provide my electronic
            signature and represent that I am at least 18 and agree to this
            website's <a href="/privacy-statement">Privacy Policy</a> and
            <a href="/terms-of-use">Terms of Use</a>.
          </p>
          <p>
            By clicking the "Get Quote" button, I provide my express written
            consent and authorization to the owner of this website and/or the
            agents of one or more of the listed businesses to contact me for
            marketing/telemarketing purposes at the number and address provided
            above, including my wireless number if provided, using live
            operators, automated telephone dialing systems, artificial voice or
            pre-recorded messages, text messages and/or emails, if applicable,
            even if I have previously registered the provided number on any
            Federal or State Do Not Call Registry. I understand that my consent
            is not required as a condition of purchasing goods or services and
            can be revoked at any time.
          </p>
          <p>
            Message and data rates may apply. Message frequency varies. Reply
            HELP for customer support or STOP to opt-out. See
            <a href="/terms-of-service">SMS Terms of Service</a> for more
            details.
          </p>
        </div>
      </section>

      <div class="recommend">
        <div class="zanzhu">
          <img alt="wellcare" src="@/assets/imgs/geico.png" />
          <img alt="Aetna" src="@/assets/imgs/century.png" />
          <img alt="blue" src="@/assets/imgs/progressive.png" />
          <img alt="cigama" src="@/assets/imgs/allstate.png" />
          <img alt="CVS_Health_logo" src="@/assets/imgs/libcrty-mutual.png" />
          <img alt="h" src="@/assets/imgs/nationwide.png" />
          <img alt="kalser" src="@/assets/imgs/travelers.png" />
        </div>
      </div>
      <div class="trademark">
        <img src="@/assets/imgs/trademark_1.png" />
        <img src="@/assets/imgs/trademark_2.png" />
        <img src="@/assets/imgs/trademark_3.png" />
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        width="40%"
        :show-close="false"
        :before-close="handleClose"
      >
        <div class="dialog_inner">
          <div class="header">
            Wait! View quotes online now.
            <i class="el-icon-circle-close close-icon" @click="handleClose"></i>
          </div>
          <div class="centont">
            <p class="tips">Click to get the best rate.</p>
            <div class="list">
              <div class="item">
                <div class="row">
                  <div class="lf">
                    <img src="@/assets/imgs/coverage-professor.svg" />
                  </div>
                  <div class="rg">
                    <el-button
                      class="link-btn"
                      @click="
                        toLink(
                          'https://pentlyconger.com/b684e266-05ff-4571-ae3b-7eaa11bdcc33'
                        )
                      "
                    >
                      View My Quote
                    </el-button>
                  </div>
                </div>
                <p
                  class="txt"
                  @click="
                    toLink(
                      'https://pentlyconger.com/b684e266-05ff-4571-ae3b-7eaa11bdcc33'
                    )
                  "
                >
                  Affordable Car Insurance Quotes
                </p>
              </div>
              <div class="item">
                <div class="row">
                  <div class="lf">
                    <img
                      src="data:image/png;base64,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"
                    />
                  </div>
                  <div class="rg">
                    <el-button
                      class="link-btn"
                      @click="
                        toLink(
                          'https://pentlyconger.com/1ecf0f4f-83a2-4257-b535-77ee7cdd3f99'
                        )
                      "
                      >View My Quote
                    </el-button>
                  </div>
                </div>
                <p
                  class="txt"
                  @click="
                    toLink(
                      'https://pentlyconger.com/1ecf0f4f-83a2-4257-b535-77ee7cdd3f99'
                    )
                  "
                >
                  Seeking the Perfect car Insurance?
                </p>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </el-main>
  </div>
</template>

<script>
// import '@/assets/js/loadJs'
import {
  ContactUsFrom,
  VFun,
  UpUsFrom,
  PingFrom,
  PostFrom,
  backSamsonads,
} from "@/api/index";
import { Encrypt, Decrypt, deepCopy } from "@/plugins/jessas";
import dayjs from "dayjs";
import { computed } from "vue";
import {
  Select,
  Option,
  Loading,
  Input,
  Row,
  Col,
  Autocomplete,
  Dialog,
} from "element-ui";
Vue.use(Select);
Vue.use(Option);
Vue.use(Autocomplete);
Vue.use(Dialog);
Vue.use(Loading.directive);
Vue.use(Row);
Vue.use(Col);
Vue.use(Input);

Vue.prototype.$loading = Loading.service;
export default {
  name: "ProcessFormDetails",
  data() {
    return {
      MyAdd: "",
      percentage: 20,
      from: {
        caryear: "",
        carmake: "",
        carmodel: "",
        caryear2: "",
        carmake2: "",
        carmodel2: "",
        cards: [],
        iscurrentlyinsured: null,
        company: "",
        ishomeowner: null,
        day: "",
        month: "",
        year: "",
        gender: "",
        married: "",
        Accidents: false,
        DUI: false,
        firstname: "",
        lastname: "",
        Military: null,
        Address: "",
        Unit: "",
        City: "",
        State: "Alabama",
        Zip: "",
        Email: "",
        phoneNum: "",
        nowcard: 1,
        birthdate: this.birthDate,
      },
      radiomakeoption: [],
      selectradiomakeoption: [],
      carmakeJson: {},
      carmodeloption: [],
      recarmodeloption: [],
      companyoption: [
        { key: " 21st Century Insurance ", value: "21st Century Insurance" },
        { key: " AAA Insurance Co. ", value: "AAA Insurance Co." },
        { key: " Allstate ", value: "Allstate Insurance" },
        { key: " American Family ", value: "American Family Insurance" },
        { key: " AMICA ", value: "Amica Insurance" },
        { key: " Country Financial ", value: "Country Financial" },
        { key: " Esurance ", value: " Esurance " },
        { key: " Farmers ", value: "Farmers Insurance" },
        { key: " Geico ", value: "Geico Casualty" },
        { key: " Liberty Mutual ", value: "Liberty Mutual Insurance" },
        { key: " Mercury ", value: "Mercury" },
        { key: " Metlife ", value: "MetLife Auto and Home" },
        { key: " Nationwide ", value: "Nationwide General Insurance" },
        { key: " Progressive ", value: "Progressive" },
        { key: " Safeco ", value: "SAFECO" },
        { key: " State Farm ", value: "State Farm County" },
        { key: " The Hartford ", value: "Hartford Accident and Indemnity" },
        { key: " Travelers ", value: "Travelers Insurance Company" },
        { key: " USAA ", value: "USAA" },
        { key: " Other ", value: "Company Not Listed" },
      ],
      // Birthdayoption: [
      //   " Jan ",
      //   " Feb ",
      //   " Mar ",
      //   " Apr ",
      //   " May ",
      //   " Jun ",
      //   " July ",
      //   " Aug ",
      //   " Sept ",
      //   " Oct ",
      //   " Nov ",
      //   " Dec ",
      // ],
      education_option: [
        "Some Or No High School",
        "High School",
        "Some College",
        "Associate Degree",
        "Bachelors Degree",
        "Masters Degree",
        "Doctoral Degree",
      ],
      occupation_option: [
        "Advertising",
        "Arts/Entertainment",
        "Banking/Mortgage",
        "Clerical/Administrative",
        "Construction/Facilities",
        "Customer Service",
        "Education/Training",
        "Engineer/Architect",
        "Government",
        "Health Care",
        "Hospitality/Travel",
        "Human Resources",
        "Insurance",
        "Internet/New Media",
        "Law Enforcement",
        "Legal",
        "Management Consulting",
        "Manufacturing",
        "Marketing",
        "Non-Profit/Volunteer",
        "Pharmaceutical/Biotech",
        "Real Estate",
        "Restaurant/Food Service",
        "Retail",
        "Retired",
        "Sales",
        "Self Employed",
        "Technology",
        "Telecommunications",
        "Transportation",
        "Other/Not Listed",
      ],
      coverage_option: [
        "No Coverage",
        "No Deductible",
        "$50",
        "$100",
        "$150",
        "$200",
        "$250",
        "$500",
        "$750",
      ],
      parking_option: [
        "Driveway",
        "Private Garage",
        "Parking Garage",
        "Parking Lot",
        "Street",
      ],
      us_state_map: {
        AL: "Alabama",
        AK: "Alaska",
        AZ: "Arizona",
        AR: "Arkansas",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DE: "Delaware",
        DC: "District Of Columbia",
        FL: "Florida",
        GA: "Georgia",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jeresy",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        RI: "Rhode Island",
        SC: "Southcarolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VA: "Virginia",
        WA: "Washington",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming",
      },
      isAddress: false,
      isCity: false,
      isZip: false,
      inputerror: false,
      isEmail: false,
      isphoneNum: false,
      isloading: true,
      numistrue: false,
      issecondcard: null,
      isfirstname: false,
      islastname: false,
      showgs: false,
      emailloading: false,
      numloading: false,
      renum: "",
      predictions: [],
      car_yaer_id: "car_yaer_",
      car_make_id: "car_make_",
      car_model_id: "car_model_",
      what_company: "car_model_",
      birthday_month_id: "birthday_month_",
      useruuid: "",
      dialogVisible: false,
      timer: null,
      howlongOption: [
        { name: "1-2 years", value: "1-2" },
        { name: "2-3 years", value: "2-3" },
        { name: "3-5 years", value: "3-5" },
        { name: "5+ years", value: "5+" },
        { name: "Less than a year", value: "Less than a year" },
      ],
      monthOptions: [
        { value: "1", name: "01" },
        { value: "2", name: "02" },
        { value: "3", name: "03" },
        { value: "4", name: "04" },
        { value: "5", name: "05" },
        { value: "6", name: "06" },
        { value: "7", name: "07" },
        { value: "8", name: "08" },
        { value: "9", name: "09" },
        { value: "10", name: "10" },
        { value: "11", name: "11" },
        { value: "12", name: "12" },
      ],
      yearOptions: [],
      dayOptions: [],
      customAttributesMap: {
        caryear: "input_1714464121973_77_902161714464121974_346",
        carmake: "input_1714464129182_314_1249051714464129182_500",
        carmodel: "input_1714464134084_237_1239881714464134084_640",
        caryear2: "input_1714464137382_223_997581714464137382_895",
        carmake2: "input_1714464139933_535_896341714464139933_432",
        carmodel2: "input_1714464143285_793_958381714464143285_122",
        iscurrentlyinsured: "input_1714464146883_777_1108951714464146883_617",
        company: "input_1714464150400_12_840271714464150400_502",
        married: "input_1715394401861_976_874841715394401861_147",
        gender: "input_1715394579277_663_663081715394579277_75",
        DUI: "input_1715394621908_54_1137571715394621908_693",
        Accidents: "input_1715394623722_883_817851715394623722_95",
        Military: "input_1715394673605_779_790931715394673605_158",
        nowcard: "input_1715394682538_41_1147191715394682538_287",
        birthdate: "date_1715394401861_33_823451715394401861_922",
        ishomeowner: "input_1715394699817_595_832021715394699817_178",
      },
    };
  },
  computed: {
    birthDate: function () {
      // return `${this.from.month}/${this.from.day}/${this.from.year}`;
      const birthMonth =
        this.from.month - 0 >= 10 ? this.from.month : `0${this.from.month}`;
      return `${this.from.year}-${birthMonth}-${this.from.day}`;
    },
  },
  async created() {
    window.localStorage.setItem("lastTime", new Date().getTime());
    window.document.onmousedown = function () {
      window.localStorage.setItem("lastTime", new Date().getTime());
    };
    window.document.onkeydown = function () {
      window.localStorage.setItem("lastTime", new Date().getTime());
    };
    window.document.onwheel = function () {
      window.localStorage.setItem("lastTime", new Date().getTime());
    };
    this.timer = window.setInterval(() => this.checkTimeout(), 10000);
    await this.loadJS(
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBBalfcMGTRGRdbeJT2LGvAjxQSRfCPtLQ&libraries=places"
    );
    await this.loadJS("/js/loadJs.js");
  },
  async mounted() {
    this.MyAdd = this.$route.params.Myadd;
    this.from.State = this.MyAdd;
    this.isfrom();
    this.generateUniqueId();
    this.radiomakeoption = localStorage.getItem("radiomakeoption")
      ? JSON.parse(localStorage.getItem("radiomakeoption"))
      : [];
    this.selectradiomakeoption = localStorage.getItem("selectradiomakeoption")
      ? JSON.parse(localStorage.getItem("selectradiomakeoption"))
      : [];
    this.carmodeloption = localStorage.getItem("carmodeloption")
      ? JSON.parse(localStorage.getItem("carmodeloption"))
      : [];
    this.recarmodeloption = localStorage.getItem("carmodeloption")
      ? JSON.parse(localStorage.getItem("carmodeloption"))
      : [];
    this.getYear();
    this.$refs.datePick.focus();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    checkTimeout() {
      //更新当前时间
      let currentTime = new Date().getTime();
      let lastTime = window.localStorage.getItem("lastTime");

      //判断是否超时
      if (currentTime - lastTime > 30 * 1000) {
        let isShow = window.localStorage.getItem("isShow");
        if (!isShow) {
          this.dialogVisible = true;
          window.localStorage.setItem("isShow", 1);
        }
        if (this.timer) {
          window.clearInterval(this.timer);
        }
      }
    },
    loadJS(url) {
      return new Promise((resolve) => {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        // IE
        if (script.readyState) {
          script.onreadystatechange = () => {
            if (
              script.readyState == "loaded" ||
              script.readyState == "complete"
            ) {
              script.onreadystatechange = null;
              resolve();
            }
          };
        } else {
          // 其他浏览器
          script.onload = function () {
            resolve();
          };
        }
        document.getElementsByTagName("head")[0].appendChild(script);
      });
    },
    isfrom() {
      if (
        !localStorage.getItem("cardfrom") ||
        !localStorage.getItem("percentage")
      ) {
        localStorage.setItem("cardfrom", JSON.stringify(this.from));
        localStorage.setItem("percentage", this.percentage);
      } else {
        this.from = JSON.parse(localStorage.getItem("cardfrom"));
        this.percentage = localStorage.getItem("percentage") - 0;
        // console.log(this.from);
      }
    },
    format(percentage) {
      return `${percentage}%` + "\n" + "Complete";
    },
    async caryear(caryear) {
      if (this.issecondcard) {
        this.from.cards[1].caryear = caryear;
        this.from.caryear2 = caryear;
      } else {
        this.from.caryear = caryear.toString();
      }
      this.radiomakeoption = [];
      this.selectradiomakeoption = [];
      // this.carmakeJson = require(`../plugins/${caryear}.json`);
      this.carmakeJson = await import(`../plugins/${caryear}.json`);
      this.carmodeloption = this.carmakeJson[caryear];
      this.radiomakeoption = this.carmakeJson[caryear].slice(0, 12);
      this.selectradiomakeoption = this.carmakeJson[caryear].slice(12);
      localStorage.setItem(
        "radiomakeoption",
        JSON.stringify(this.radiomakeoption)
      );
      localStorage.setItem(
        "selectradiomakeoption",
        JSON.stringify(this.selectradiomakeoption)
      );
      this.nest();
    },
    async clickcarmake(carmake) {
      if (this.issecondcard) {
        this.from.cards[1].carmake = carmake;
        this.from.carmake2 = carmake;
      } else {
        this.from.carmake = carmake;
      }
      this.carmodeloption = [];
      // this.carmakeJson = require(`../plugins/${this.from.caryear}.json`);
      this.carmakeJson = await import(
        `../plugins/${
          !this.issecondcard ? this.from.caryear : this.from.caryear2
        }.json`
      );
      this.carmakeJson[
        !this.issecondcard ? this.from.caryear : this.from.caryear2
      ].forEach((e) => {
        if (e[carmake]) {
          this.carmodeloption = e[carmake];
        }
      });
      localStorage.setItem(
        "carmodeloption",
        JSON.stringify(this.carmodeloption)
      );
      this.recarmodeloption = deepCopy(this.carmodeloption);
      setTimeout(() => {
        this.nest();
      });
    },
    moelclick(carmodel) {
      if (this.issecondcard) {
        this.from.cards[1].carmodel = carmodel;
        this.from.carmodel2 = carmodel;
        this.from.nowcard = 5;
        return;
      } else {
        this.from.carmodel = carmodel;
      }
      setTimeout(() => {
        this.nest();
      });
    },
    isaddsecond(issecond) {
      if (issecond) {
        this.issecondcard = true;
        this.from.cards.push(
          {
            caryear: this.from.caryear,
            carmake: this.from.carmake,
            carmodel: this.from.carmodel,
          },
          { caryear: "", carmake: "", carmodel: "" }
        );
        setTimeout(() => {
          this.from.nowcard = 1;
        });
      } else {
        this.issecondcard = false;
        setTimeout(() => {
          this.nest();
        });
      }
    },
    iscurrentlyinsured(iscurrentlyinsured) {
      this.from.iscurrentlyinsured = iscurrentlyinsured;
      if (iscurrentlyinsured) {
        setTimeout(() => {
          this.nest();
        });
      } else {
        setTimeout(() => {
          this.from.nowcard = 7;
          this.percentage = this.percentage + 5;
        });
      }
    },
    whatcompany(company) {
      this.from.company = company;
      setTimeout(() => {
        this.nest();
      });
    },
    howlong(time) {
      this.from.howlong = time;
      setTimeout(() => {
        this.nest();
      });
    },
    ishomeowner(ishomeowner) {
      this.from.ishomeowner = ishomeowner;
      setTimeout(() => {
        this.nest();
      });
    },
    birthdayContinue() {
      // console.log(this.birthDate);
      if (!this.from.day || !this.from.month || !this.from.year) {
        this.istruebirth = true;
        this.inputerror = true;
      } else {
        this.istrueyear = false;
        this.inputerror = false;
        this.from.birthdate = `${this.from.year}/${this.from.month}/${this.from.day}`;
        this.nest();
      }
    },
    whatGender(gender) {
      this.from.gender = gender;
      setTimeout(() => {
        this.nest();
      });
    },
    querySearch(queryString, cb) {
      // var carmodeloption = this.carmodeloption;
      // console.log(queryString);
      var carmodeloption = JSON.parse(JSON.stringify(this.recarmodeloption));
      this.carmodeloption = queryString
        ? carmodeloption.filter(this.createFilter(queryString))
        : this.recarmodeloption;
      // console.log(this.recarmodeloption);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.name
          .toLowerCase()
          .includes(queryString.toLowerCase());
      };
    },
    // yearcontinue() {
    //   var myDate = new Date();
    //   var age = myDate.getFullYear() - this.from.birthyear;
    //   if (age < 16 || age > 80) {
    //     this.istrueyear = true;
    //     this.inputerror = true;
    //   } else {
    //     this.istrueyear = false;
    //     this.inputerror = false;
    //     this.nest();
    //   }
    // },
    isMarried(Married) {
      this.from.married = Married;
      setTimeout(() => {
        this.nest();
      });
    },
    isAccidents(isAccidents) {
      this.from.Accidents = isAccidents;
      setTimeout(() => {
        this.nest();
      });
    },
    isDUI(isDUI) {
      this.from.DUI = isDUI;
      setTimeout(() => {
        this.nest();
      });
    },
    whatname() {
      // console.log(this.from)
      if (!this.from.firstname && !this.from.lastname) {
        this.isfirstname = true;
        this.islastname = true;
      } else if (!this.from.firstname) {
        this.isfirstname = true;
      } else if (!this.from.lastname) {
        this.islastname = true;
      } else {
        this.isfirstname = false;
        this.islastname = false;
        this.nest();
      }
    },
    isMilitary(isMilitary) {
      this.from.Military = isMilitary;
      setTimeout(() => {
        this.nest();
      });
    },
    addaddress() {
      const card12 = [
        !this.from.Address,
        !this.from.City,
        !this.from.Zip,
        this.from.Zip?.length != 5,
      ];
      if (card12.indexOf(true) === -1) {
        this.isAddress = false;
        this.isCity = false;
        this.isZip = false;
        this.$refs.cityinput.focus();
        this.$refs.cityinput.blur();
        this.$refs.stateinput.focus();
        this.$refs.stateinput.blur();
        this.$refs.zipinput.focus();
        this.$refs.zipinput.blur();
        this.$refs.autocomplete.focus();
        this.nest();
      } else {
        this.from.Address ? (this.isAddress = false) : (this.isAddress = true);
        this.from.City ? (this.isCity = false) : (this.isCity = true);
        this.from.Zip ? (this.isZip = false) : (this.isZip = true);
        this.from.Zip?.length != 5 ? (this.isZip = true) : (this.isZip = false);
      }
    },
    async clickEmail() {
      if (this.emailloading) {
        return;
      }
      const chexkemail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!this.from.Email || !chexkemail.test(this.from.Email)) {
        this.isEmail = true;
      } else {
        this.emailloading = true;
        const res = await VFun({
          data: Encrypt(
            this.from.Email + ",2841e22ed3754f98aa7c36d7a3848ec1,email,dsfsdf"
          ),
        });
        if (Decrypt(res).split(",")[1] === "False") {
          this.isEmail = true;
          this.emailloading = false;
        } else {
          this.isEmail = false;
          this.emailloading = false;
          this.nest();
        }
      }
    },
    // formatPhoneNumber(phoneNumberString) {
    //   // console.log(phoneNumberString)
    //   if (phoneNumberString) {
    //     this.renum = phoneNumberString;
    //     var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    //     var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    //   }
    //   // if (!this.from.phoneNum || this.from.phoneNum.length < 10) {
    //   // 	this.isphoneNum = true
    //   // 	this.numistrue = false
    //   // } else if (match) {
    //   // 	const res = await VerifyPhoneApi(this.from.phoneNum)
    //   // 	if (res.valid) {
    //   // 		this.isphoneNum = false
    //   // 		var intlCode = (match[1] ? '+1 ' : '');
    //   // 		this.from.phoneNum =  [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    //   // 		this.numistrue = true
    //   // 	} else {
    //   // 		this.isphoneNum = true
    //   // 		this.numistrue = false
    //   // 	}
    //   // }
    //   if (!this.from.phoneNum || this.from.phoneNum.length < 10) {
    //     this.isphoneNum = true;
    //     this.numistrue = false;
    //   } else if (match) {
    //     this.isphoneNum = false;
    //     var intlCode = match[1] === undefined ? "+1 " : "";
    //     this.from.phoneNum = [intlCode, match[0]].join("");
    //     this.numistrue = true;
    //   }
    // },
    nameInput(event, name) {
      this.from[name] =
        event.trim().charAt(0).toUpperCase() + event.trim().slice(1);
      this[`is${name}`] = this.from[name] ? false : true;
    },
    formatPhoneInput(input) {
      // 移除非数字字符和+1前缀
      var formatted = input.replace(/\+1\s*|[^\d]/g, "");
      // 插入-号
      if (formatted.length >= 3) {
        formatted =
          formatted.substring(0, 3) +
          (formatted.length > 3 ? "-" + formatted.substring(3) : "");
      }
      if (formatted.length >= 7) {
        formatted =
          formatted.substring(0, 7) +
          (formatted.length > 7 ? "-" + formatted.substring(7) : "");
      }
      this.from.phoneNum = formatted;
    },
    formatPhoneNumber(phoneNumberString) {
      if (phoneNumberString) {
        this.renum = phoneNumberString;
        var cleaned = "" + phoneNumberString;
        var match = cleaned.match(/^(\d{3})-(\d{3})-(\d{4})$/);
      }
      if (!this.from.phoneNum) {
        this.isphoneNum = true;
        this.numistrue = false;
      } else if (this.from.phoneNum.length < 10) {
        this.phoneError = "Please enter 10-digit U.S. phone number";
        this.isphoneNum = true;
        this.numistrue = false;
      } else if (match) {
        this.isphoneNum = false;
        // var intlCode = "+1 ";
        // this.from.phoneNum = [intlCode, match[0]].join("");
        this.numistrue = true;
      }
    },

    async fromcontinue() {
      this.formatPhoneNumber();
      if (!this.isphoneNum) {
        this.numloading = true;
        // console.log(this.renum)
        const res = await VFun({
          data: Encrypt(
            this.from.phoneNum +
              ",2841e22ed3754f98aa7c36d7a3848ec1,phone,dsfsdf"
          ),
        }).then(() => {
          if (Decrypt(res).split(",")[1] === "True") {
            this.isphoneNum = false;
            this.numistrue = true;
            this.numloading = false;
            this.from.phoneNum = this.from.phoneNum.replace(/-/g, "");
            let subfrom = JSON.parse(localStorage.getItem("usercardfrom"));
            if (!subfrom) {
              subfrom = {};
            }
            subfrom.name = this.from.firstname + " " + this.from.lastname;
            subfrom.phone = this.from.phoneNum;
            subfrom.other = this.from;
            subfrom.other.date = this.getDate();
            if (this.numistrue) {
              // UpUsFrom(subfrom);
              this.submitToLeed()
                .then(() => {
                  this.isloading = false;
                  const loading = this.$loading({
                    lock: true,
                    text: "",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                  });
                  let _this = this;
                  window.setTimeout(() => {
                    loading.close();
                    _this.$router.push({ path: "/Result" }).catch(() => {});
                  }, 2000);
                  EF.conversion({
                    offer_id: 1669,
                    amount: 0.01,
                  });
                })
                .catch((error) => {
                  console.error(error);
                  this.isloading = false;
                });
            }
          } else {
            this.isphoneNum = true;
            this.numistrue = false;
            this.numloading = false;
          }
        });
      }
    },
    back() {
      if (this.from.nowcard === 1) {
        this.$router.go(-1);
        return;
      }
      if (this.from.nowcard === 1 && this.issecondcard) {
        this.from.nowcard = 4;
        this.percentage = this.percentage - 5;
        localStorage.setItem("cardfrom", JSON.stringify(this.from));
        localStorage.setItem("percentage", this.percentage);
        return;
      }
      if (this.from.nowcard === 8 && !this.from.iscurrentlyinsured) {
        this.from.nowcard = 5;
        this.percentage = this.percentage - 5;
        localStorage.setItem("cardfrom", JSON.stringify(this.from));
        localStorage.setItem("percentage", this.percentage);
        return;
      }
      this.from.nowcard--;
      this.percentage = this.percentage - 5;
      localStorage.setItem("cardfrom", JSON.stringify(this.from));
      localStorage.setItem("percentage", this.percentage);
    },
    nest() {
      this.from.nowcard++;
      if (this.percentage !== 100) {
        // this.percentage = this.percentage + 5;
        this.percentage =
          this.issecondcard && this.from.nowcard <= 3
            ? 15 + 5 * (this.from.nowcard + 2)
            : 20 + 5 * (this.from.nowcard - 1);
      }
      localStorage.setItem("cardfrom", JSON.stringify(this.from));
      localStorage.setItem("percentage", this.percentage);
      this.upuserdata(this.from);
    },
    autocompleteSearch(queryString, cb) {
      if (!queryString) {
        this.predictions = [];
        return;
      }
      const autocompleteService = new google.maps.places.AutocompleteService();
      autocompleteService.getPlacePredictions(
        {
          input: queryString,
          language: "en",
          componentRestrictions: { country: "US" },
        },
        (predictions) => {
          this.predictions = [];
          predictions.forEach((e) => {
            this.predictions.push({
              value: e.description,
            });
          });
          cb(this.predictions);
          // this.predictions = predictions || [];
          // cb(predictions.map((prediction) => prediction.description));
        }
      );
    },
    handleSelect(item) {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: item.value }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          const address = results[0];
          const streetNumber = address.address_components.find((component) =>
            component.types.includes("street_number")
          );
          const route = address.address_components.find((component) =>
            component.types.includes("route")
          );
          const locality =
            address.address_components.find((component) =>
              component.types.includes("locality")
            ) ||
            address.address_components.find((component) =>
              component.types.includes("administrative_area_level_2")
            );
          const administrativeArea = address.address_components.find(
            (component) =>
              component.types.includes("administrative_area_level_1")
          );
          const postalCode = address.address_components.find((component) =>
            component.types.includes("postal_code")
          );
          const neighborhood = address.address_components.find((component) =>
            component.types.includes("neighborhood")
          );
          this.from.Address = `${streetNumber ? streetNumber.long_name : ""} ${
            route ? route.long_name : ""
          }  ${neighborhood ? " , " + neighborhood.long_name : ""}`;
          // this.from.City = locality ? locality.long_name : "";
          // this.from.State = administrativeArea && administrativeArea.short_name;
          // this.from.Zip = postalCode && postalCode.long_name;

          this.$set(this.from, "City", locality ? locality.long_name : "");

          this.$set(
            this.from,
            "State",
            administrativeArea && administrativeArea.short_name
          );
          this.$set(this.from, "Zip", postalCode && postalCode.long_name);
        }
      });
    },
    generateUniqueId() {
      if (!localStorage.getItem("useruuid")) {
        const timestamp = new Date().getTime();
        const random = Math.random().toString(36).substring(2, 10);
        this.useruuid = timestamp.toString(36) + random;
        localStorage.setItem("useruuid", this.useruuid);
        this.Initializedata();
      } else {
        this.useruuid = localStorage.getItem("useruuid", this.useruuid);
        // this.Initializedata();
      }
    },
    getDate() {
      // 获取用户所在时区与 UTC 时间之间的偏移量（以分钟为单位）
      const offset = new Date().getTimezoneOffset();
      // 将偏移量转换为毫秒数
      const offsetMilliseconds = offset * 60 * 1000;
      // 获取当前时间的时间戳（UTC 时间）
      const currentUTC = new Date().getTime();
      // 计算北京时间的时间戳
      const beijingTime = currentUTC + 8 * 60 * 60 * 1000 + offsetMilliseconds;
      // 将北京时间转换为 Date 对象
      // const beijingDate = new Date(beijingTime).toLocaleString();
      const beijingDate = dayjs(beijingTime).format("YYYY/MM/DD HH:mm:ss");
      // 计算UTC时区
      const utc = `UTC ${0 - offset / 60 > 0 ? "+" : ""}${0 - offset / 60}`;
      return `${beijingDate}    ${utc === "UTC +8" ? "- CN" : ""}`;
    },
    // 进入表单发送生成请求
    async Initializedata(from) {
      const subfrom = {};
      const useruuid = localStorage.getItem("useruuid");
      const quoteselect = JSON.parse(
        localStorage.getItem("cardfrom")
      )?.quoteselect;

      subfrom.leadStatus = 1;
      subfrom.leadSource = "PRIVATEAUTOQUOTE.COM";
      subfrom.firstName = useruuid;
      //进入表单提交quoteselect
      subfrom.customAttributes = [
        {
          id: "input_1714464153231_645_1023901714464153231_791",
          customAttributeId: "input_1714464153231_645_1023901714464153231_791",
          customAttributeName:
            "input_1714464153231_645_1023901714464153231_791",
          customAttributeType: "input",
          customAttributeValue: `unversalLeadid:${leadid}`,
        },
        {
          id: "input_1714464210815_510_739981714464210815_639",
          customAttributeId: "input_1714464210815_510_739981714464210815_639",
          customAttributeName: "input_1714464210815_510_739981714464210815_639",
          customAttributeType: "input",
          customAttributeValue: `trustedForm_id:${window?.trustedForm?.id}`,
        },
      ];
      // console.log(JSON.stringify(subfrom));
      const res = await ContactUsFrom(JSON.stringify(subfrom));
      localStorage.setItem("usercardfrom", JSON.stringify(res.data));
    },

    // 更新表单数据
    async upuserdata(from, numistrue, backres) {
      var userip = JSON.parse(localStorage.getItem("userip"));
      let subfrom = JSON.parse(
        JSON.parse(localStorage.getItem("usercardfrom"))
      );
      let customAttributesMap = this.customAttributesMap;
      if (subfrom) {
        subfrom = { ...subfrom?.lead };
        let subfromDta = { ...subfrom };
        let attributeNames = [];
        let isUpdate = [];
        if (!Array.isArray(subfromDta.customAttributes)) {
          subfromDta.customAttributes = [];
        }
        // let source = localStorage.getItem("source");
        // if (!subfrom) {
        //   subfrom = {
        //     other: {
        //       date: getDate(),
        //     },
        //   };
        // }
        if (numistrue) {
          subfromDta.firstName = from.firstname;
          subfromDta.lastName = from.lastname;
          attributeNames.push("firstName", "lastName");
        }
        if (from.phoneNum) {
          subfromDta.skypeName = from.phoneNum.replace(/\+1\s*|[^\d]/g, "");
          // subfromDta.phoneNumbers = [
          //   {
          //     id: "lead_phone_input",
          //     phoneType: "Business",
          //     phoneTypeCode: "PHONE_BUSINESS",
          //     phoneNumber: from.phoneNum.replace(/\+1\s*|[^\d]/g, ""),
          //   },
          // ];
          attributeNames.push("skypeName");
          isUpdate.push("isSkypeNameUpdate=true");
        }
        if (from.Email) {
          subfromDta.emailAddresses = [
            {
              emailAddress: from.Email,
              emailTypeCode: "BUSINESS",
              emailType: "Business",
              id: "cont_email_input",
              communicationId: 1,
            },
          ];
          attributeNames.push("emailAddresses");
          isUpdate.push("isEmailAddressUpdate=true");
        }
        if (from.Address) {
          subfromDta.addresses = [
            {
              addressId: 1,
              addressAttributeId: "address_section_attr_id",
              countryId: 176,
              addressTypeCode: "1",
              addressType: "Billing Address",
              addressLine1: from.Address,
              city: from.City,
              state: this.us_state_map[from.state],
              stateCode: from.State,
              zipCode: from.Zip,
              county: "",
              countryName: "United States",
              countryCode: "US",
              deliveryInstructions: null,
              addressGroupName: "Address1",
            },
          ];

          attributeNames.push("address");
          isUpdate.push("isAddressUpdate=true");
        }
        // 记录IP地址
        if (userip) {
          const isIPAddress = subfromDta.customAttributes.find((attr) =>
            attr.customAttributeValue.includes("IPAddress")
          );

          if (
            !isIPAddress ||
            !isIPAddress?.customAttributeValue?.split(":")[1]
          ) {
            const ipAddress = {
              id: "input_1715399205944_480_1296931715399205944_61",
              customAttributeId:
                "input_1715399205944_480_1296931715399205944_61",
              customAttributeName:
                "input_1715399205944_480_1296931715399205944_61",
              customAttributeType: "input",
              customAttributeValue: `IPAddress:${userip.ip}`,
            };

            subfromDta.customAttributes.push(ipAddress);
            subfromDta.customAttributes.push(
              {
                id: "input_1714464153231_645_1023901714464153231_791",
                customAttributeId:
                  "input_1714464153231_645_1023901714464153231_791",
                customAttributeName:
                  "input_1714464153231_645_1023901714464153231_791",
                customAttributeType: "input",
                customAttributeValue: `unversalLeadid:${leadid}`,
              },
              {
                id: "input_1714464210815_510_739981714464210815_639",
                customAttributeId:
                  "input_1714464210815_510_739981714464210815_639",
                customAttributeName:
                  "input_1714464210815_510_739981714464210815_639",
                customAttributeType: "input",
                customAttributeValue: `trustedForm_id:${window?.trustedForm?.id}`,
              }
            );

            attributeNames.push("customAttributes");
            isUpdate.push("isCustomAttributesUpdate=true");
          }
        }
        console.log(from, "from");
        for (const key in from) {
          if (customAttributesMap.hasOwnProperty(key)) {
            if (key == "company") {
              console.log(from[key], customAttributesMap[key], "from[key]");
            }

            const attributeId = customAttributesMap[key];
            const customAttributeValue = `${key}:${from[key]}`;
            const newAttribute = {
              id: attributeId,
              customAttributeId: attributeId,
              customAttributeName: attributeId,
              customAttributeType: "input",
              customAttributeValue,
            };
            // 找到是否已经存在相同 id 的属性
            const existingIndex = subfromDta.customAttributes.findIndex(
              (attr) => attr.id === attributeId
            );

            // 如果已经存在相同 id 的属性，则替换掉旧的属性
            if (existingIndex !== -1) {
              subfromDta.customAttributes[existingIndex] = newAttribute;
            } else {
              // 否则将新属性添加到 customAttributes 数组中
              subfromDta.customAttributes.push(newAttribute);
            }

            attributeNames.push("customAttributes");
            isUpdate.push("isCustomAttributesUpdate=true");
          }
        }

        attributeNames = Array.from(new Set(attributeNames));
        isUpdate = Array.from(new Set(isUpdate));
        // console.log(subfromDta, " subfromDta.customAttributes");
        // console.log(isUpdate.join("&"), "isUpdate");
        // console.log(JSON.stringify(subfromDta), "JSON.stringify(subfromDta)");

        const res = await UpUsFrom(
          JSON.stringify(subfromDta),
          subfromDta?.leadId,
          JSON.stringify(attributeNames),
          isUpdate.join("&")
        );
        localStorage.setItem("usercardfrom", JSON.stringify(res.data));
      }
    },
    toLink(link) {
      window.open(link);
    },

    getYear() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 80;
      const options = [];

      for (let year = startYear; year <= currentYear - 16; year++) {
        options.push({ value: year, name: year });
      }
      this.yearOptions = options.reverse();

      // console.log(this.$refs.year.value);
    },
    changeMonth(value) {
      // console.log(value);
      this.dayOptions = [];
      for (let i = 1; i <= 28; i++) {
        this.dayOptions.push({
          value: i.toString(),
          name: (i < 10 ? "0" : "") + i.toString(),
        });
      }
      if (["1", "3", "5", "7", "8", "10", "12"].indexOf(value) >= 0) {
        this.dayOptions = this.dayOptions.concat([
          { value: "29", name: "29" },
          { value: "30", name: "30" },
          { value: "31", name: "31" },
        ]);
        return;
      }
      if (["4", "6", "9", "11"].indexOf(value) >= 0) {
        this.dayOptions = this.dayOptions.concat([
          { value: "29", name: "29" },
          { value: "30", name: "30" },
        ]);
        return;
      }
      if (value == 2) {
        let year = this.from.year;
        if (year) {
          if (
            (parseInt(year) % 4 == 0 && parseInt(year) % 100 != 0) ||
            parseInt(year) % 400 == 0
          ) {
            this.dayOptions = this.dayOptions.concat([
              { value: "29", name: "29" },
            ]);
            // console.log(this.dayOptions)

            return;
          }
        }
      }
    },
    async submitToLeed() {
      // const cookie = document.cookie.split(";");
      // const leads = cookie.filter((el) => el.includes("leadid_token"));
      // const leadid_token = leads[0].split("=")[1];
      // console.log(leadid_token, "leadid_tiken")
      const source = localStorage.getItem("source");
      const tid = localStorage.getItem("tid");

      if (tid) await backSamsonads(tid);

      const submitData = {
        // Key: "ecddc4a78773d65b29cd7728eed4f650ea5213532005493c65f296b282850645",
        Key: "7f4bf4fb33c1308eabf629ff17da00dfa1f49c810487b39c23f49e6c15e89d9d",
        API_Action: "pingPostLead",
        TYPE: 33,
        SRC: source ? source : "BSM-Internalfacebook",
        Landing_Page: "https://privateautoquote.com/",
        Sub_ID: 81,
        Pub_ID: 1,
        // Return_Best_Price: 1,
        // Project: "Carpenters",
        LeadiD_Token: leadid,
        // Trusted_Form_URL: `https://api.trustedform.com/${window.trustedForm.token}`,
        Trusted_Form_URL: window.trustedForm.token,
        Trusted_Form_Token: window.trustedForm.id,
        TCPA_Consent: "Yes",
        TCPA_Language: "English",
        // State: "AK",
        Driver_1_Gender: "Male",
        // TCPAText:
        // "TCPA (Telephone Consumer Protection Act) Compliance Statement:By providing your contact information, you consent to receive calls, text messages, and/or emails from us or our authorized representatives regarding products and services. This consent applies to both landline and mobile phone numbers. Please note that your consent is not a condition of purchasing any products or services. If you wish to opt out of receiving further communications, you can do so by contacting us directly or using the unsubscribe option provided in our communications.We respect your privacy and adhere to all applicable TCPA regulations. Your information will not be shared with any third parties for marketing purposes without your explicit consent.If you have any questions or concerns regarding our TCPA compliance or the use of your personal information, please contact us.",
      };
      const userip = JSON.parse(localStorage.getItem("userip"));
      submitData.IP_Address = userip?.ip;
      submitData.Driver_1_First_Name = this.from.firstname;
      submitData.Driver_1_Last_Name = this.from.lastname;
      submitData.Driver_1_City = this.from.City;
      submitData.Driver_1_State = Object.keys(this.us_state_map).includes(
        this.from.State
      )
        ? this.from.State
        : Object.keys(this.us_state_map)[
            Object.values(this.us_state_map).findIndex(
              (item) => item.toUpperCase() === this.from.State.toUpperCase()
            )
          ];
      submitData.Driver_1_Email = this.from.Email;
      submitData.Driver_1_Daytime_Phone = this.from.phoneNum;
      submitData.Driver_1_Zip = this.from.Zip;
      submitData.Driver_1_Address = this.from.Address;
      submitData.Driver_1_Current_Residence = this.from.ishomeowner
        ? "Own"
        : "Other";
      submitData.Driver_1_Birthdate = this.birthDate;
      submitData.Driver_1_Age = dayjs().year() - this.from.year;

      // submitData.Driver_1_Birthdate = "12/23/1980";
      submitData.Driver_1_Marital_Status = this.from.married;
      submitData.Driver_1_Tickets_Accidents_Claims_Past_3_Years =
        this.from.Accidents;
      submitData.Driver_1_DUI_DWI_In_The_Past_5_Years = this.from.DUI;
      // submitData.Driver_1_Insurance_Company = this.from.company;

      submitData.Driver_1_Licensed_State = submitData.Driver_1_State;
      submitData.Driver_1_Gender = this.from.gender;

      submitData.Vehicle_1_Year = this.from.caryear;
      submitData.Vehicle_1_Make = this.from.carmake;
      submitData.Vehicle_1_Model = this.from.carmodel;

      submitData.Driver_1_Insurance_Company = this.from.company
        ? this.from.company
        : "Not Currently Insured";

      submitData.Driver_1_Education =
        this.education_option[
          Math.floor(Math.random() * this.education_option.length)
        ];
      // submitData.Driver_1_Licensed_State = Object.keys(this.us_state_map)[
      //   Math.floor(Math.random() * Object.keys(this.us_state_map).length)
      // ];

      submitData.Driver_1_License_Status = "Active";
      submitData.Driver_1_Occupation =
        this.occupation_option[
          Math.floor(Math.random() * this.occupation_option.length)
        ];
      submitData.Driver_1_Filing_Required = "None";
      submitData.Vehicle_1_Desired_Comprehensive_Coverage =
        this.coverage_option[
          Math.floor(Math.random() * this.coverage_option.length)
        ];
      submitData.Vehicle_1_Parking =
        this.parking_option[
          Math.floor(Math.random() * this.parking_option.length)
        ];
      submitData.Vehicle_1_Ownership = "Owned";
      submitData.Vehicle_1_Primary_Use = "Commute To/From Work";
      submitData.Driver_1_Additional_Vehicles = this.issecondcard
        ? "Yes"
        : "No";
      submitData.Driver_1_Insured_Past_30_Days = this.from.iscurrentlyinsured
        ? "Yes"
        : "No";
      // submitData.Driver_1_Credit_Rating = this.from.Address;
      // submitData.Driver_1_License_Status = this.from.Address;
      // submitData.Driver_1_Licensed_State = this.from.Address;
      // submitData.Driver_1_Age_When_First_Licensed = this.from.Address;
      // submitData.Driver_1_Filing_Required = this.from.Address;
      // submitData.Driver_1_Education = this.from.Address;
      // submitData.Driver_1_Occupation = this.from.Address;
      // submitData.Driver_1_Current_Residence = this.from.Address;
      // submitData.Driver_1_Insured_Past_30_Days = this.from.Address;
      // submitData.Driver_1_Bankruptcy_In_Past_5_Years = this.from.Address;
      // submitData.Driver_1_Additional_Drivers = this.from.Address;
      // submitData.Driver_1_Additional_Vehicles = this.from.Address;
      // submitData.Driver_1_Reposessions_In_The_Past_5_Years = this.from.Address;

      // submitData.Vehicle_1_Ownership = this.from.Address;
      // submitData.Vehicle_1_Primary_Use = this.from.Address;
      // submitData.Vehicle_1_Average_One_Way_Mileage = this.from.Address;
      // submitData.Vehicle_1_Annual_Mileage = this.from.Address;
      // submitData.Vehicle_1_Parking = this.from.Address;
      // submitData.Vehicle_1_Average_Days_Per_Week_Used = this.from.Address;
      // submitData.Vehicle_1_Desired_Collision_Coverage = this.from.Address;
      // submitData.Vehicle_1_Desired_Comprehensive_Coverage = this.from.Address;

      let data = {
        Key: submitData.Key,
        API_Action: submitData.API_Action,
        // Return_Best_Price: submitData.Return_Best_Price,
        TYPE: submitData.TYPE,
        SRC: submitData.SRC,
        Mode: "ping",
        Driver_1_State: submitData.Driver_1_State,
        Driver_1_Zip: submitData.Driver_1_Zip,
        IP_Address: submitData.IP_Address,
        Vehicle_1_Year: submitData.Vehicle_1_Year,
        Vehicle_1_Make: submitData.Vehicle_1_Make,
        Vehicle_1_Model: submitData.Vehicle_1_Model,
        Driver_1_Birthdate: submitData.Driver_1_Birthdate,
        TCPA_Consent: submitData.TCPA_Consent,
        LeadiD_Token: submitData.LeadiD_Token,
        Driver_1_Gender: submitData.Driver_1_Gender,
        Driver_1_Daytime_Phone: submitData.Driver_1_Daytime_Phone,
        Driver_1_Marital_Status: submitData.Driver_1_Marital_Status,
        Driver_1_DUI_DWI_In_The_Past_5_Years:
          submitData.Driver_1_DUI_DWI_In_The_Past_5_Years,

        Driver_1_Education: submitData.Driver_1_Education,
        Driver_1_Licensed_State: submitData.Driver_1_Licensed_State,
        Driver_1_License_Status: submitData.Driver_1_License_Status,
        Driver_1_Occupation: submitData.Driver_1_Occupation,
        Driver_1_Filing_Required: submitData.Driver_1_Filing_Required,
        Vehicle_1_Desired_Comprehensive_Coverage:
          submitData.Vehicle_1_Desired_Comprehensive_Coverage,
        Vehicle_1_Parking: submitData.Vehicle_1_Parking,
        Vehicle_1_Ownership: submitData.Vehicle_1_Ownership,
        Vehicle_1_Primary_Use: submitData.Vehicle_1_Primary_Use,
        Driver_1_Insurance_Company: submitData.Driver_1_Insurance_Company,
        Driver_1_Current_Residence: submitData.Driver_1_Current_Residence,
        Driver_1_Additional_Vehicles: submitData.Driver_1_Additional_Vehicles,
        Driver_1_Insured_Past_30_Days: submitData.Driver_1_Insured_Past_30_Days,
      };
      if (this.issecondcard) {
        submitData.Vehicle_2_Year = this.from.caryear2;
        submitData.Vehicle_2_Make = this.from.carmake2;
        submitData.Vehicle_2_Model = this.from.carmodel2;
        data = {
          ...data,
          Vehicle_2_Year: submitData.Vehicle_2_Year,
          Vehicle_2_Make: submitData.Vehicle_2_Make,
          Vehicle_2_Model: submitData.Vehicle_2_Model,
        };
      }
      if (
        submitData.Driver_1_Insurance_Company &&
        submitData.Driver_1_Insurance_Company !== "Company Not Listed"
      ) {
        // console.log(submitData.Driver_1_Insurance_Company);
        submitData.Vehicle_1_Coverage_Type = "Basic";
        submitData.Driver_1_Insured_Since = dayjs()
          .subtract(5, "year")
          .format("YYYY-MM-DD");
        submitData.Driver_1_Policy_Expiration_Date = dayjs()
          .add(1, "month")
          .format("YYYY-MM-DD");

        data = {
          ...data,
          Vehicle_1_Coverage_Type: submitData.Vehicle_1_Coverage_Type,
          Driver_1_Insured_Since: submitData.Driver_1_Insured_Since,
          Driver_1_Policy_Expiration_Date:
            submitData.Driver_1_Policy_Expiration_Date,
        };
      }
      // console.log(data);
      const res = await PingFrom(data);
      if (res) {
        //获得leadid
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(res.data, "text/xml");
        // console.log("xmlDoc", xmlDoc);
        const pingStatus =
          xmlDoc.getElementsByTagName("status")[0]?.childNodes[0]?.nodeValue;
        const leadId =
          xmlDoc.getElementsByTagName("lead_id")[0]?.childNodes[0]?.nodeValue;
        const pingError =
          xmlDoc.getElementsByTagName("error")[0]?.childNodes[0]?.nodeValue;
        this.form.nowcard = "done";
        this.upuserdata(this.from, true);
        if (pingStatus === "Success") {
          //  发送POST模式
          const postRes = await PostFrom(
            // JSON.stringify({
            //   Test_Lead: "1",
            //   Request: { Lead_ID: leadId, ...submitData, Mode: "post" },
            // })
            { Lead_ID: leadId, ...submitData, Mode: "post" }
          );

          const postParser = new DOMParser();
          const postXmlDoc = postParser.parseFromString(
            postRes.data,
            "text/xml"
          );
          const postStatus =
            postXmlDoc.getElementsByTagName("status")[0]?.childNodes[0]
              ?.nodeValue;
          const price =
            postXmlDoc.getElementsByTagName("price")[0]?.childNodes[0]
              ?.nodeValue;
          if (price) {
            if (tid) await backSamsonads(tid, price); //回传网盟系统
            // this.upuserdata({ postStatus, price });
          } else {
            const postError =
              postXmlDoc.getElementsByTagName("error")[0]?.childNodes[0]
                ?.nodeValue;
            // this.upuserdata({ postStatus, postError });
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/layout.scss";

.process_form {
  margin-top: 70px;

  .el-main {
    padding: 0px;
    overflow: hidden;
    background: rgb(246, 249, 254);

    .section {
      min-height: 650px;
      margin-bottom: 20px;

      .title {
        font-weight: 900;
        font-size: 35px;
        text-align: center;
        line-height: 4;
        color: rgba(28, 56, 136, 1);
      }

      .num {
        font-size: 20px;
        font-weight: 700;
        display: block;
        text-align: center;
        color: rgba(82, 178, 222, 1);
        margin: 0px auto 10px auto;
      }

      .cart {
        width: 35%;
        min-height: 350px;
        background: rgba(255, 255, 255, 1);
        border-radius: 15px;
        box-shadow: 0px 0px 19px rgb(145, 211, 255, 0.5);
        margin: 0px auto;
        padding: 30px 5% 60px 5%;
        text-align: center;
        position: relative;

        .title {
          color: #000;
          font-size: 20px;
          font-weight: 700;
          text-align: center;
          line-height: 2;
        }

        .tips {
          font-size: 28px;
          font-weight: 700;
          text-align: center;
          margin: 30px 20px 20px 20px;
        }

        .btn-group {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;

          .btn {
            float: left;
            // padding: 15px 20px;

            color: rgba(28, 56, 136, 1);
            background: rgba(255, 255, 255, 1);
            margin: 0 7.5px 15px;
            border-radius: 5px;
            font-size: 24px;
            font-weight: 450;
            text-align: center;
            border: 1px solid rgba(82, 178, 222, 1);
            overflow: hidden;
            position: relative;
            .checkbox-btn {
              position: absolute;
              top: 0;
              left: 0;
              opacity: 0;
            }
            label {
              display: block;
              padding: 15px 0;
              cursor: pointer;
            }
          }

          .btn:hover,
          .btn.active {
            cursor: pointer;
            color: rgba(255, 255, 255, 1);
            background: rgba(100, 176, 212, 1);
            border: 1px solid rgba(82, 178, 222, 1);
          }
          .w20 {
            width: 17%;
          }
          .w100 {
            width: 106px;
            height: 50px;
            font-size: 16px;
            margin: 0px 20px;
          }

          .w145 {
            width: 46%;
            overflow: hidden;
          }

          .clearflex {
            width: 100%;
            clear: both;
            height: 10px;
          }
        }

        .birth_group {
          justify-content: space-evenly;

          .birth_input {
            width: 20%;
          }
        }

        .row {
          width: 100%;

          .car_make {
            width: 97%;
            font-size: 24px;

            .el-input__inner {
              border: 1px solid rgba(82, 178, 222, 1);
            }
          }

          .car_model {
            width: 97%;
            font-size: 24px;
            margin-bottom: 20px;

            .el-input__inner {
              border: 1px solid rgba(82, 178, 222, 1);
            }
          }
        }

        .checked {
          padding: 25px 0px;

          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;

          .btn {
            float: left;
            // padding: 15px 20px;

            color: rgba(28, 56, 136, 1);
            background: rgba(255, 255, 255, 1);
            margin: 0 7.5px 15px;
            border-radius: 5px;
            font-size: 24px;
            font-weight: 450;
            text-align: center;
            border: 1px solid rgba(82, 178, 222, 1);
            overflow: hidden;
            position: relative;
            .checkbox-btn {
              position: absolute;
              top: 0;
              left: 0;
              opacity: 0;
            }
            label {
              display: block;
              padding: 15px 0;
              cursor: pointer;
            }
          }

          .btn:hover,
          .btn.active {
            cursor: pointer;
            color: rgba(255, 255, 255, 1);
            background: rgba(100, 176, 212, 1);
            border: 1px solid rgba(82, 178, 222, 1);
          }
          .w20 {
            width: 17%;
          }
          .w100 {
            width: 106px;
            height: 50px;
            font-size: 16px;
            margin: 0px 20px;
          }

          .w145 {
            width: 46%;
            overflow: hidden;
          }

          .clearflex {
            width: 100%;
            clear: both;
            height: 10px;
          }
          .checked_btn {
            width: 106px;
            height: 50px;
            font-size: 16px;
            font-weight: 400;
            margin: 0px 20px;
            color: rgba(28, 56, 136, 1);
            border: 1px solid rgba(82, 178, 222, 1);
            position: relative;
            .checkbox-btn {
              position: absolute;
              top: 0;
              left: 0;
              opacity: 0;
            }
            label {
              display: block;
              // padding: 15px 0;
              cursor: pointer;
            }
          }

          .checked_btn:hover,
          .checked_btn.active {
            background: rgba(82, 178, 222, 1);
            color: rgba(255, 255, 255, 1) !important;
          }
        }

        .next_btn {
          background: rgba(255, 150, 150, 1);
          color: rgba(255, 255, 255, 1);
          width: 128px;
          height: 46px;
          font-size: 20px;
          font-weight: 700;
        }

        .md20 {
          margin-bottom: 20px;
        }

        .optiongroup {
          margin-top: 10px;
          overflow: hidden;

          .addressinputright {
            padding-right: 15px;
            margin-bottom: 2rem;
          }

          .mobaddressinputleft {
            margin-bottom: 2rem;
            width: 100%;
          }

          .carmakestyle {
            width: 100%;
          }
        }

        .input_txt {
          .el-input__inner {
            border: 1px solid rgba(82, 178, 222, 1);
            font-size: 20px;
            height: 45px;
            line-height: 45px;
          }
        }

        .el-input {
          font-size: 20px;
        }

        .yearinput,
        .phone_txt {
          .el-input__inner {
            text-align: center;
          }
        }

        .error {
          margin-top: 20px;
          border-radius: 20px;
          border: 1px solid rgba(14, 50, 162, 1);

          .error_inner {
            border-radius: 20px;
            padding: 10px;
            margin: 2px;
            border: 1px solid rgba(14, 50, 162, 0.5);
            color: rgba(28, 56, 136, 1);
            font-size: 14px;
            font-weight: 500;
            overflow: hidden;

            .fsize20 {
              font-size: 20px;
            }
          }
        }

        .errorinput {
          .el-input__inner {
            border: 1px solid #eb737a;
          }
        }

        .errortext {
          color: #eb737a;
          padding: 0px;
          height: 25px;
          line-height: 25px;
          text-align: left;
          font-size: 14px;
        }
      }

      .content {
        width: 50%;
        margin: 40px auto 100px auto;
        border-radius: 25px;
        padding: 20px 3%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 19px rgba(199, 199, 199, 0.4);

        p {
          color: rgba(108, 99, 100, 1);
          font-size: 14px;

          a {
            color: #2f9ee9;
          }
        }
      }

      .back-icon {
        position: absolute;
        top: 40px;
        left: 30px;
        cursor: pointer;
      }
    }

    .recommend {
      text-align: center;

      .r_content {
        font-size: 16px;
        color: rgba(28, 56, 136, 1);
        font-weight: 700;
        padding: 10px 0px;
      }

      .zanzhu {
        width: 100%;
        background: rgb(255, 255, 255);
        background-repeat: no-repeat;
        background-size: cover;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
        text-align: center;

        img {
          vertical-align: middle;
          margin: 20px 30px;
          width: 110px;
        }
      }
    }

    .trademark {
      text-align: center;
      margin: 30px 0px;

      img {
        padding: 50px;
      }
    }
  }

  .el-dialog {
    border-radius: 15px;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .dialog_inner {
    height: 450px;
    background: rgb(82, 178, 222);
    border-radius: 15px;

    .header {
      height: 55px;
      line-height: 55px;
      text-align: center;
      color: rgb(255, 255, 255);
      font-size: 20px;
      position: relative;

      .close-icon {
        position: absolute;
        right: 20px;
        top: 10px;
        cursor: pointer;
        font-size: 25px;
      }
    }

    .centont {
      margin: 20px;
      padding: 10px;
      background: rgba(255, 255, 255, 1);
      border-radius: 15px;

      .tips {
        margin-left: 10px;
        line-height: 2;
        color: rgba(69, 165, 241, 1);
      }

      .list {
        height: 300px;
        overflow-y: scroll;
        padding: 0px 10px;

        &::-webkit-scrollbar {
          width: 5px;
        }

        &::-webkit-scrollbar-track {
          background-color: #fff;
        }

        &::-webkit-scrollbar-thumb {
          background: rgb(82, 178, 222);
          border-radius: 15px;
          max-height: 45px;
        }

        .item {
          text-align: center;
          border: 1px solid rgb(82, 178, 222);
          margin-bottom: 20px;
          padding: 10px;
          border-radius: 15px;

          .row {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .lf {
              img {
                max-width: 90%;
              }
            }
          }

          .txt {
            margin-top: 10px;
            cursor: pointer;
          }

          .txt:hover {
            color: rgb(69, 165, 241);
          }

          .link-btn {
            background: rgb(82, 178, 222);
            color: rgb(255, 255, 255);
          }

          .link-btn:hover,
          .link-btn:active {
            background: rgb(0, 189, 189);
            color: rgb(255, 255, 255);
          }
        }
      }
    }
  }
}

.is-fullscreen .el-loading-spinner {
  background-image: url("../assets/loading.webp");
  background-repeat: no-repeat;
  background-size: 150px 150px;
  height: 150px;
  width: 100%;
  background-position: center;
  top: 40%;
  transform: rotate(0deg);
  animation: path 5s linear infinite;
}

@keyframes path {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.is-fullscreen .el-loading-spinner .el-icon-loading,
.is-fullscreen .el-loading-spinner .el-loading-text {
  display: none;
}

.el-loading-mask.is-fullscreen {
  background-color: transparent;
}

@media screen and (max-width: 1300px) {
  .process_form {
    .el-main {
      .section {
        .cart {
          width: 50%;
          min-height: 330px;
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .process_form {
    .el-main {
      .section {
        .title {
          font-size: 35px;
          margin-top: 20px;
        }

        .cart {
          width: calc(70% - 20px);
          margin: 20px auto;
          padding: 10px 10px 60px 10px;
          min-height: 380px;

          .optiongroup {
            .addressinputright {
              padding-right: 15px;
            }

            .addressinputleft {
              margin-bottom: 2rem;
            }

            .mobaddressinputleft {
              width: 100%;
            }

            .addressinputleft:last-child {
              padding-left: 15px;
            }
          }

          .back-icon {
            top: 38px;
          }

          .el-input {
            font-size: 18px;
          }

          .input_txt {
            .el-input__inner {
              font-size: 18px;
            }
          }

          .btn-group {
            .btn {
              font-size: 18px;
            }
            .w20 {
              width: 25%;
            }
            .w145 {
              font-size: 18px;
              width: 40%;
            }
          }
        }

        .content {
          width: 90%;
        }
      }

      .recommend {
        .zanzhu {
          background: rgba(255, 255, 255, 1);
        }
      }

      .trademark {
        img {
          padding-bottom: 10px;
        }
      }
    }

    .dialog_inner {
      height: 450px;
      background: rgb(82, 178, 222);
      border-radius: 15px;

      .header {
        height: 55px;
        line-height: 55px;
        text-align: center;
        color: rgb(255, 255, 255);
        font-size: 20px;
        position: relative;

        .close-icon {
          position: absolute;
          right: 20px;
          top: 10px;
          cursor: pointer;
          font-size: 25px;
        }
      }
    }
  }

  .el-dialog {
    width: 56% !important;

    .tips {
      color: rgba(69, 165, 241, 1);
    }
  }
}

@media screen and (max-width: 768px) {
  .process_form {
    margin-top: 76px;

    .el-main {
      .section {
        min-height: 600px;

        .title {
          font-size: 26px;
          line-height: 1;
        }

        .cart {
          width: calc(96% - 20px);
          margin: 20px auto;
          padding: 10px 10px 50px 10px;
          min-height: 370px;

          .optiongroup {
            .addressinputright {
              padding-right: 0px;
            }

            .addressinputleft {
              margin-bottom: 2rem;
            }

            .mobaddressinputleft {
              width: 95.55%;
            }

            .addressinputleft:last-child {
              padding-left: 15px;
            }
          }

          .back-icon {
            top: 38px;
          }

          .el-input {
            font-size: 16px;
          }

          .input_txt {
            .el-input__inner {
              font-size: 16px;
            }
          }

          .btn-group {
            .btn {
              font-size: 14px;
            }
            .w20 {
              width: 25%;
            }
            .w145 {
              font-size: 14px;
              width: 45%;
            }
          }
        }

        .content {
          width: 90%;
        }
      }

      .recommend {
        .zanzhu {
          background: rgba(255, 255, 255, 1);
        }
      }

      .trademark {
        img {
          padding-bottom: 10px;
        }
      }
    }

    .dialog_inner {
      height: 450px;
      background: rgb(82, 178, 222);
      border-radius: 15px;

      .header {
        height: 55px;
        line-height: 55px;
        text-align: center;
        color: rgb(255, 255, 255);
        font-size: 17px;
        position: relative;

        .close-icon {
          position: absolute;
          right: 10px;
          top: 10px;
          cursor: pointer;
          font-size: 25px;
        }
      }

      .centont {
        margin-top: 10px;

        .list .item {
          .link-btn {
            font-size: 12px;
          }
        }
      }
    }
  }

  .el-dialog {
    width: 96% !important;
  }
}

@media screen and (max-width: 516px) {
  .process_form {
    .dialog_inner {
      .centont {
        margin-top: 10px;

        .list .item {
          .row {
            flex-wrap: wrap;
            text-align: center;

            .lf,
            .rg {
              width: 100%;
            }
          }
        }
      }
    }
  }

  .birth_group {
    justify-content: space-evenly;

    .birth_input {
      width: 30% !important;
    }
  }
}
</style>
